import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useApi } from "../lib/api";
import { useMe } from "../lib/me";

export function PaymentSuccess() {
  const api = useApi();
  const { refresh } = useMe();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setStatus("failed");
    let n = 0, off = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) return setStatus("failed");
      } catch (e) {
        console.warn("Payment status check failed, retrying", e); // transient; keep polling
      }
      if (!off && ++n < 15) setTimeout(poll, 2000); else if (!off) setStatus("pending");
    };
    poll();
    return () => { off = true; };
  }, [api, params, refresh]);
  return (
    <div className="spotlight min-h-[80vh] grid place-items-center px-6" data-testid="payment-success-page">
      <div className="panel max-w-md w-full p-8 text-center rise">
        {status === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-yellow-400" /><p className="mt-4 font-semibold">Confirming your payment…</p></>}
        {status === "paid" && <><CheckCircle2 className="mx-auto h-10 w-10 text-[#39ff6a]" /><h1 className="mt-4 text-2xl font-black" data-testid="payment-status-paid">You're in.</h1><p className="mt-2 text-sm text-zinc-400">Access is unlocked.</p></>}
        {status === "pending" && <><Loader2 className="mx-auto h-10 w-10 text-yellow-400" /><p className="mt-4 font-semibold" data-testid="payment-status-pending">Still processing — check My Purchases in a minute.</p></>}
        {status === "failed" && <><XCircle className="mx-auto h-10 w-10 text-pink-400" /><p className="mt-4 font-semibold" data-testid="payment-status-failed">The payment didn't go through.</p></>}
        <div className="mt-6 flex justify-center gap-4 text-sm">
          <Link to="/" className="text-yellow-300" data-testid="payment-back-lobby">Lobby</Link>
          <Link to="/purchases" className="text-zinc-300" data-testid="payment-my-purchases">My purchases</Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="spotlight min-h-[80vh] grid place-items-center px-6" data-testid="payment-cancel-page">
      <div className="panel max-w-md w-full p-8 text-center">
        <XCircle className="mx-auto h-10 w-10 text-zinc-500" />
        <h1 className="mt-4 text-2xl font-black">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-zinc-400">No money was taken.</p>
        <Link to="/" className="mt-6 inline-block text-yellow-300" data-testid="payment-cancel-back">Back to the lobby</Link>
      </div>
    </div>
  );
}
